// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"45":"9d6ab1c8","185":"b2e916cf"}[chunkId] + ".css";
};